import { useState } from 'react';

import axios from 'axios';

import Layout from '@/modules/core/components/Layout';

const VoucherPage = () => {
  const [formVisible, setFormVisible] = useState(true);
  const [iframeVisible, setIframeVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
  });
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMessage('');

    try {
      const columns = [
        formData.name,
        formData.phone,
        formData.email,
        formData.city,
      ];

      await axios.post('/api/spreadwriter', {
        fileId: '1wCgCFQarkS7pQnrBdrd4YIxYGcxWzm1bMKtR-rYt2ZU',
        columns,
        NotifyByMail: false,
        userDetails: formData,
      });

      setFormVisible(false);
      setIframeVisible(true);
      // Announce success to screen readers
      const statusElement = document.getElementById('status-message');
      if (statusElement) {
        statusElement.textContent =
          'Formulaire soumis avec succès. La carte est maintenant affichée.';
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi vers Google Sheet:", error);
      setErrorMessage(
        "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="relative w-full lg:mt-0 mt-10 mb-20 lg:mb-40 pt-10 lg:pt-20 pb-40 px-4 rounded-xl shadow-sm border border-gray-400 bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: 'url(/media/tt-bg.webp)' }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <img
          className="w-40 mx-auto mb-4"
          src="/media/logo-tt.svg"
          alt="Logo Tunisie Télécom"
          width={160}
          height={80}
        />
        <img
          className="absolute bottom-4 right-10 opacity-30 w-24 mx-auto mb-4"
          src="/media/logo-tt.svg"
          alt=""
          width={96}
          height={48}
          aria-hidden="true"
        />
        <h1 className="text-3xl font-black mb-2 text-[#223B7B]">
          Accédez à votre forfait Internet adapté
        </h1>
      </div>

      {/* Accessibility status messages */}
      <div
        id="status-message"
        className="sr-only"
        role="status"
        aria-live="polite"
      ></div>

      {formVisible && (
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-lg font-semibold text-purple-700 mb-10">
            Veuillez remplir le formulaire ci-dessous pour accéder à la carte de
            Tunisie Télécom. Cela nous permettra de vous proposer le forfait
            Internet le plus adapté à votre adresse.
          </p>

          {errorMessage && (
            <div
              role="alert"
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4"
            >
              {errorMessage}
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className="max-w-md mx-auto bg-white shadow-lg border-purple-400 rounded-xl p-6 space-y-5 border"
            aria-labelledby="form-heading"
            noValidate
          >
            <h2
              id="form-heading"
              className="text-lg font-semibold text-gray-700 mb-4"
            >
              Formulaire de contact
            </h2>

            <div className="flex flex-col items-start">
              <label htmlFor="name" className="text-gray-700 mb-2 font-medium">
                Nom et Prénom{' '}
                <span className="text-red-500" aria-hidden="true">
                  *
                </span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Entrez votre nom et prénom"
                className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={formData.name}
                onChange={handleChange}
                required
                aria-required="true"
              />
            </div>

            <div className="flex flex-col items-start">
              <label htmlFor="phone" className="text-gray-700 mb-2 font-medium">
                Numéro de téléphone{' '}
                <span className="text-red-500" aria-hidden="true">
                  *
                </span>
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Entrez votre numéro de téléphone"
                className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={formData.phone}
                onChange={handleChange}
                required
                aria-required="true"
                pattern="[0-9]{2}[\s]?[0-9]{3}[\s]?[0-9]{3}"
                aria-describedby="phone-format"
              />
              <span id="phone-format" className="text-xs text-gray-500 mt-1">
                Format: XX XXX XXX
              </span>
            </div>

            <div className="flex flex-col items-start">
              <label htmlFor="email" className="text-gray-700 mb-2 font-medium">
                Email{' '}
                <span className="text-red-500" aria-hidden="true">
                  *
                </span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="votre@email.com"
                className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={formData.email}
                onChange={handleChange}
                required
                aria-required="true"
              />
            </div>

            <div className="flex flex-col items-start">
              <label htmlFor="city" className="text-gray-700 mb-2 font-medium">
                Ville{' '}
                <span className="text-red-500" aria-hidden="true">
                  *
                </span>
              </label>
              <input
                type="text"
                id="city"
                name="city"
                placeholder="Entrez votre ville"
                className="w-full border border-gray-300 p-3 rounded focus:outline-none focus:ring-2 focus:ring-purple-500"
                value={formData.city}
                onChange={handleChange}
                required
                aria-required="true"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 text-white font-semibold py-3 rounded-xl hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 transition duration-200"
              disabled={submitting}
              aria-busy={submitting}
            >
              {submitting
                ? 'Chargement...'
                : 'Afficher la carte Tunisie Télécom'}
            </button>

            <p className="text-xs text-gray-500 mt-2">
              <span className="text-red-500" aria-hidden="true">
                *
              </span>{' '}
              Indique un champ obligatoire
            </p>
          </form>
        </div>
      )}

      {iframeVisible && (
        <div className="w-full h-full flex items-center justify-center my-10">
          <iframe
            src="https://geo.tunisietelecom.tn/mytaghtia/"
            style={{ width: '95%', height: '80vh', border: 'none' }}
            title="Carte de couverture Tunisie Télécom"
            aria-label="Carte interactive montrant la couverture réseau de Tunisie Télécom"
          />
        </div>
      )}
    </div>
  );
};

export default VoucherPage;

VoucherPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
